import { IApplicationState } from '../../types/redux';

export const selectListingBreadcrumbs = (state: IApplicationState) => {
  return state.listingOffers.breadcrumbs;
};
